import { DataLegitimacy } from './Common';

export enum UserType {
  CLIENT = 'client',
}

export enum UserAccountType {
  CUSTOMER = 'CUSTOMER',
}

export enum UserEmailVerificationStatus {
  VERIFIED = 'VERIFIED'
}

export type UserPreferences = {
  language: string,
  currency: string,
  timezone: string,
  unitsOfMeasureTemplateName: string,
  marketingCommunications: unknown | null,
  unitsOfMeasure: {
    yield: string,
    combineMeasurementsFlowSensorLag: string,
    equipmentSpeed: string,
    planterSeederMeasurementsStopDelay: string,
    dryFertilizerApplication: string,
    soilCationExchangeCapacity: string,
    growingDegreeUnits: string,
    planterSeederMeasurementsSeedExit: string,
    moisture: string,
    liquidFertilizerApplication: string,
    singulation: string,
    planterSeederMeasurementsStartDelay: string,
    wind: string,
    combineMeasurementsMoistureLag: string,
    airTemperature: string,
    planterSeederMeasurementsWheelDistance: string,
    tractorGpsMeasurements: string,
    population: string,
    rowSpacing: string,
    precipitation: string,
    probabilityOfPrecipitation: string,
    landArea: string,
    combineMeasurementsGpsOffsets: string,
  }
};

export type User = {
  id: number;
  clientId: number;
  firstName: string;
  lastName: string;
  email: string;
  userType: UserType
  tosAcceptedAt: string;
  updatedAt: string;
  firstViews: number;
  emailVerificationStatus: UserEmailVerificationStatus;
  phone: string;
  city: string;
  dataLegitimacy: DataLegitimacy;
  createdAt: string;
  source: string;
  address1: string;
  mailchimp: boolean;
  address2: string;
  zip: string;
  firstAdministrativeDivisionCode: string;
  accountType: UserAccountType;
  uuid: string;
  enabled: boolean;
  countryCode: string;
  preferences: UserPreferences;
};
